import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  readonly #reasons = signal<string[]>([]);
  readonly isLoading = computed(() => this.#reasons().length > 0);

  addReason(reason: string) {
    this.#reasons.update((reasons) => [...reasons, reason]);
  }

  removeReason(reason: string) {
    this.#reasons.update((reasons) => reasons.filter((r) => r !== reason));
  }

  clearReasons() {
    this.#reasons.set([]);
  }
}
